import styled from 'styled-components'
import { theme } from '../../../../styles/theme'

export const Header = styled.header`
  display: flex;
  align-items: center;
  font-size: 14px;
  font-style: normal;
  font-weight: 700;
  gap: 5px;
  margin: 10px 0 10px 10px;
  color: ${theme.colors.black};
`

export const Container = styled.div`
  margin: 15px;
  @media (min-width: 768px) {
    margin: 0 28%;
  }
`

export const WrapperFAQ = styled.div`
  display: flex;
  justify-content: end;
  margin-bottom: 30px;
`

export const Section = styled.section`
  font-size: 18px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: 0.2px;
  color: ${theme.colors.green2};
`

export const ContainerTerms = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin-top: 10%;
`

export const TermsContainer = styled.div`
  margin-top: 20px;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 5px;
  max-height: 40vh;
  width: 100%;
  overflow-y: auto;
  padding: 20px;

  h2 {
    text-align: center;
    margin-bottom: 25px;
    color: ${theme.colors.gray700};
  }

  p {
    color: ${theme.colors.gray600};
  }

  ul,
  ol {
    margin: 20px;
  }
`

export const LogoImage = styled.img`
  max-width: 100%;
  height: auto;
`
